const USERS_URL = "/users";
export async function getUser(axiosPrivate) {
  const storedUser = localStorage.getItem("user");
  // Assuming username is stored as a plain string
  const username = storedUser;

  try {
    const response = await axiosPrivate.get(`${USERS_URL}/${username}`);
    return response.data;
  } catch (err) {
    console.error(err);
  }
}
